"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOTSPOT_CONFIG_FIELD_DESCRIPTIONS = exports.HOTSPOT_CONFIG_FIELD_LABELS = exports.MAX_HOTSPOT_CACHE_TTL_SECONDS = exports.MIN_HOTSPOT_CACHE_TTL_SECONDS = exports.MAX_HOTSPOT_ACTIVE_WINDOW_MINUTES = exports.MIN_HOTSPOT_ACTIVE_WINDOW_MINUTES = exports.MAX_HOTSPOT_GAP_METERS = exports.MIN_HOTSPOT_GAP_METERS = exports.MAX_HOTSPOT_RANGE_METERS = exports.MIN_HOTSPOT_RANGE_METERS = exports.MAX_HOTSPOT_MIN_USERS = exports.MIN_HOTSPOT_MIN_USERS = exports.DEFAULT_HOTSPOT_CACHE_TTL_SECONDS = exports.DEFAULT_HOTSPOT_ACTIVE_WINDOW_MINUTES = exports.DEFAULT_HOTSPOT_MIN_GAP_METERS = exports.DEFAULT_HOTSPOT_RANGE_METERS = exports.DEFAULT_HOTSPOT_MIN_USERS = void 0;
exports.buildDefaultHotspotConfig = buildDefaultHotspotConfig;
exports.parseHotspotConfig = parseHotspotConfig;
exports.validateHotspotConfigForSave = validateHotspotConfigForSave;
exports.DEFAULT_HOTSPOT_MIN_USERS = 5;
exports.DEFAULT_HOTSPOT_RANGE_METERS = 150;
exports.DEFAULT_HOTSPOT_MIN_GAP_METERS = 100;
exports.DEFAULT_HOTSPOT_ACTIVE_WINDOW_MINUTES = 15;
exports.DEFAULT_HOTSPOT_CACHE_TTL_SECONDS = 60;
exports.MIN_HOTSPOT_MIN_USERS = 2;
exports.MAX_HOTSPOT_MIN_USERS = 1000;
exports.MIN_HOTSPOT_RANGE_METERS = 10;
exports.MAX_HOTSPOT_RANGE_METERS = 5000;
exports.MIN_HOTSPOT_GAP_METERS = 0;
exports.MAX_HOTSPOT_GAP_METERS = 5000;
exports.MIN_HOTSPOT_ACTIVE_WINDOW_MINUTES = 1;
exports.MAX_HOTSPOT_ACTIVE_WINDOW_MINUTES = 24 * 60;
exports.MIN_HOTSPOT_CACHE_TTL_SECONDS = 5;
exports.MAX_HOTSPOT_CACHE_TTL_SECONDS = 3600;
exports.HOTSPOT_CONFIG_FIELD_LABELS = {
  minUsersForHotspot: 'Minimum users',
  rangeMeters: 'Detection range (meters)',
  minGapMeters: 'Minimum gap between hotspots (meters)',
  activeWindowMinutes: 'Active window (minutes)',
  cacheTtlSeconds: 'Cache TTL (seconds)'
};
exports.HOTSPOT_CONFIG_FIELD_DESCRIPTIONS = {
  minUsersForHotspot: 'A cluster needs at least this many users within range to count as a hotspot.',
  rangeMeters: 'Radius used to detect nearby users; also bounds how far a user can be from a hotspot center.',
  minGapMeters: 'Minimum distance required between the edges of two hotspots. Hotspots closer than this are merged into one larger hotspot.',
  activeWindowMinutes: 'Users whose last location ping is older than this are excluded from hotspot detection.',
  cacheTtlSeconds: 'How long the computed hotspot list is cached before being recalculated.'
};
function buildDefaultHotspotConfig() {
  return {
    minUsersForHotspot: exports.DEFAULT_HOTSPOT_MIN_USERS,
    rangeMeters: exports.DEFAULT_HOTSPOT_RANGE_METERS,
    minGapMeters: exports.DEFAULT_HOTSPOT_MIN_GAP_METERS,
    activeWindowMinutes: exports.DEFAULT_HOTSPOT_ACTIVE_WINDOW_MINUTES,
    cacheTtlSeconds: exports.DEFAULT_HOTSPOT_CACHE_TTL_SECONDS
  };
}
function parseIntInRange(value, fallback, min, max) {
  if (typeof value === 'number' && Number.isFinite(value) && Number.isInteger(value) && value >= min && value <= max) {
    return value;
  }
  return fallback;
}
function parseHotspotConfig(raw) {
  const defaults = buildDefaultHotspotConfig();
  if (!raw || typeof raw !== 'object') {
    return defaults;
  }
  const value = raw;
  return {
    minUsersForHotspot: parseIntInRange(value.minUsersForHotspot, defaults.minUsersForHotspot, exports.MIN_HOTSPOT_MIN_USERS, exports.MAX_HOTSPOT_MIN_USERS),
    rangeMeters: parseIntInRange(value.rangeMeters, defaults.rangeMeters, exports.MIN_HOTSPOT_RANGE_METERS, exports.MAX_HOTSPOT_RANGE_METERS),
    minGapMeters: parseIntInRange(value.minGapMeters, defaults.minGapMeters, exports.MIN_HOTSPOT_GAP_METERS, exports.MAX_HOTSPOT_GAP_METERS),
    activeWindowMinutes: parseIntInRange(value.activeWindowMinutes, defaults.activeWindowMinutes, exports.MIN_HOTSPOT_ACTIVE_WINDOW_MINUTES, exports.MAX_HOTSPOT_ACTIVE_WINDOW_MINUTES),
    cacheTtlSeconds: parseIntInRange(value.cacheTtlSeconds, defaults.cacheTtlSeconds, exports.MIN_HOTSPOT_CACHE_TTL_SECONDS, exports.MAX_HOTSPOT_CACHE_TTL_SECONDS)
  };
}
function validateHotspotConfigForSave(value) {
  var _ref, _ref2, _ref3, _ref4, _checkIntRange;
  if (!value || typeof value !== 'object') {
    return {
      message: 'hotspotConfig must be an object.'
    };
  }
  const config = value;
  const checkIntRange = (key, min, max) => {
    const raw = config[key];
    if (typeof raw !== 'number' || !Number.isInteger(raw)) {
      return {
        message: "hotspotConfig.".concat(key, " must be an integer.")
      };
    }
    if (raw < min || raw > max) {
      return {
        message: "hotspotConfig.".concat(key, " must be between ").concat(min, " and ").concat(max, ".")
      };
    }
    return null;
  };
  return (_ref = (_ref2 = (_ref3 = (_ref4 = (_checkIntRange = checkIntRange('minUsersForHotspot', exports.MIN_HOTSPOT_MIN_USERS, exports.MAX_HOTSPOT_MIN_USERS)) !== null && _checkIntRange !== void 0 ? _checkIntRange : checkIntRange('rangeMeters', exports.MIN_HOTSPOT_RANGE_METERS, exports.MAX_HOTSPOT_RANGE_METERS)) !== null && _ref4 !== void 0 ? _ref4 : checkIntRange('minGapMeters', exports.MIN_HOTSPOT_GAP_METERS, exports.MAX_HOTSPOT_GAP_METERS)) !== null && _ref3 !== void 0 ? _ref3 : checkIntRange('activeWindowMinutes', exports.MIN_HOTSPOT_ACTIVE_WINDOW_MINUTES, exports.MAX_HOTSPOT_ACTIVE_WINDOW_MINUTES)) !== null && _ref2 !== void 0 ? _ref2 : checkIntRange('cacheTtlSeconds', exports.MIN_HOTSPOT_CACHE_TTL_SECONDS, exports.MAX_HOTSPOT_CACHE_TTL_SECONDS)) !== null && _ref !== void 0 ? _ref : null;
}
//# sourceMappingURL=hotspot-config.js.map